import { SortDirection } from '@angular/material/sort';
import { FilterOrderApi } from '@core/services/http-params/model/api-http-params.model';

export type SortEvent = {
  sortName: string;
  sortDir: SortDirection;
};

export const sortDomainToApi = (domain: Partial<SortEvent>): FilterOrderApi => {
  if (domain.sortDir === 'asc') {
    return {
      columnOrder: domain.sortName,
      orderDirection: 'ASC',
    };
  } else {
    return {
      columnOrder: domain.sortName,
      orderDirection: domain.sortDir === 'desc' ? 'DESC' : undefined,
    };
  }
};
